import { Grid2x2 } from 'lucide-react';
import { useStore } from '../store';
import { KeyTile } from './KeyTile';

export function KeyPanel() {
  const panel = useStore((s) => s.panel);
  const user = useStore((s) => s.user);
  const hotkeys = useStore((s) => s.settings.hotkeys);

  if (!panel || panel.keys.length === 0) {
    return (
      <div className="empty">
        <Grid2x2 size={56} />
        <h3>No keys assigned</h3>
        <p>An administrator needs to assign a panel to {user?.displayName ?? 'you'}.</p>
      </div>
    );
  }

  return (
    <>
      <div className="panel-head">
        <h1>{panel.name}</h1>
        <span className="muted mono">
          {user?.displayName}
          {hotkeys ? ' · keys 1–0 = talk · esc = release' : ''}
        </span>
      </div>
      <div className="keys">
        {panel.keys.map((k, i) => (
          <KeyTile key={k.id} keyConfig={k} index={i} />
        ))}
      </div>
    </>
  );
}
